import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-nav', 'arrowKeys', 'Use arrow keys to navigate menu.');
